// PageTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getOrCreateUserId } from './utils/userTracker';
import axios from './api/axios';
import useAxiosFunction from './hooks/useAxiosFunction';

export default function PageTracker({siteId, nameOfCompleting, timeDate, userType, categoryId, description, 
    contacted,  contactEmail,  contactNumber
}) {
  const [response, error, loading, axiosFetch] = useAxiosFunction();
  const location = useLocation();

  useEffect(() => {
    const userSessionId = getOrCreateUserId();
    const navigationData = {
      userSessionId,
      path: location.pathname,
      timestamp: new Date().toISOString(),
      "siteId": siteId? siteId.id : 0,
      nameOfCompleting,
      timeDate,
      userType,
      "categoryId":categoryId? categoryId.category_order : 0,
      description, 
      contacted,
      contactEmail,
      contactNumber
    };

    axiosFetch({
      axiosInstance: axios, // or pass a custom instance if needed
      method: 'POST',
      url: '/track-navigation',
      requestConfig: {
        headers: { 'Content-Type': 'application/json' },
        data: navigationData,
      },
    });
  }, [location]);

  return null; // no UI
}
